<template>
  <div>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list dense nav>
        <v-subheader class="text-uppercase font-weight-bold">Menu</v-subheader>
        <v-list-item v-for="(item, index) in menu" :key="index" :to="item.link">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-btn class="d-md-none drawer-button" rounded @click="drawer = !drawer">
      <v-icon right>mdi-menu</v-icon>
    </v-btn>

    <v-app-bar flat height="80" color="transparent">
      <v-container class="py-0 px-0 px-sm-2 fill-height">
        <router-link to="/" class="d-flex align-center text-decoration-none mr-2 toolbar3-min-width">
          <img
            src="@/assets/images/cts.png"
            alt=""
            height="130"
            class="mr-0"
            style="position: absolute; top: 0; margin-left: 20px"
          />
        </router-link>

        <v-spacer></v-spacer>

        <div v-if="$vuetify.breakpoint.smAndUp" class="d-none d-md-block mt-2 justify-end dynwidth" >
          <v-row justify="end" no-gutters>
            <v-btn
              v-for="(item, index) in menu"
              :key="index"
              :to="item.link"
              text

              :class="[$route.path === `${item.link}` && 'plus-jakarta-sans-800 underline-click']"
              class="mx-1 plus-jakarta-sans-300 mb-1 hide-link hover-underline-animation center"
              v-html="item.title"
            >
            </v-btn>
          </v-row>
        </div>

      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import { menu } from './menus.js';

export default {
  data() {
    return {
      drawer: null,
      menu,
    };
  },
};
</script>

<style scoped>
.drawer-button {
  position: fixed;
  top: 64px;
  left: -22px;
  z-index: 6;
}

.toolbar3-min-width {
  min-width: 130px;
}

/* Extra Small (xs) - below 600px */
@media (max-width: 599px) {
  /* styles for xs only */
  .dynwidth {
    max-width: 300px
  }
}

/* Small (sm) - 600px to 959px */
@media (min-width: 600px) and (max-width: 959px) {
  /* styles for sm only */
  .dynwidth {
    max-width: 400px
  }
}

/* Medium (md) - 960px to 1263px */
@media (min-width: 960px) and (max-width: 1263px) {
  /* styles for md only */
  .dynwidth {
    max-width: 600px
  }
}

/* Large (lg) - 1264px to 1903px */
@media (min-width: 1264px) and (max-width: 1903px) {
  /* styles for lg only */
  .dynwidth {
    max-width: 900px
  }
}

/* Extra Large (xl) - 1904px and above */
@media (min-width: 1904px) {
  /* styles for xl and up */
  .dynwidth {
    max-width: 1800px
  }
}

</style>
<style lang="scss">
v-btn:before {
}
</style>
